const SUGGESTIONS = [
  { title: "Réveil en douceur", tagline: "Un café, la lumière du matin, rien ne presse", cfg: { mood: "chill", mood2: "petillant", blend: 30, duration_minutes: 30 } },
  { title: "Deep work", tagline: "Zéro distraction, juste toi et ta to-do", cfg: { mood: "focus", duration_minutes: 60 } },
  { title: "Pré-soirée", tagline: "On se prépare, on monte le son", cfg: { mood: "fete", mood2: "petillant", blend: 40, duration_minutes: 45 } },
  { title: "Souvenirs d'été", tagline: "Les tubes qui sentent la crème solaire", cfg: { mood: "nostalgique", mood2: "petillant", blend: 40, duration_minutes: 45 } },
  { title: "Pluie contre la vitre", tagline: "Plaid, thé chaud et pensées qui vagabondent", cfg: { mood: "melancolique", mood2: "chill", blend: 50, duration_minutes: 30 } },
  { title: "Énergie pétillante", tagline: "Pour danser dans la cuisine", cfg: { mood: "petillant", duration_minutes: 20 } },
  { title: "Retour vers le passé", tagline: "80s, 90s, 2000s : la machine à remonter le temps", cfg: { mood: "nostalgique", duration_minutes: 60 } },
  { title: "Focus doux", tagline: "Concentré mais détendu", cfg: { mood: "focus", mood2: "chill", blend: 40, duration_minutes: 45 } },
  { title: "Dimanche lent", tagline: "Pas de réveil, pas de plan", cfg: { mood: "chill", duration_minutes: 90 } },
  { title: "Main character", tagline: "Tu marches dans la rue comme dans un clip", cfg: { mood: "petillant", mood2: "fete", blend: 30, duration_minutes: 30 } },
  { title: "Cœur en vrac", tagline: "Laisse couler, ça fait du bien", cfg: { mood: "melancolique", duration_minutes: 30 } },
  { title: "Dancefloor salon", tagline: "Les meubles poussés, la boule disco allumée", cfg: { mood: "fete", duration_minutes: 60 } },
  { title: "Nostalgie chill", tagline: "Les vieux sons, version coussin", cfg: { mood: "nostalgique", mood2: "chill", blend: 50, duration_minutes: 45 } },
  { title: "Sprint créatif", tagline: "Idées qui fusent, rythme qui pousse", cfg: { mood: "focus", mood2: "petillant", blend: 30, duration_minutes: 30 } },
];

const dayIndex = (date) => Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 86400000) + date.getFullYear() * 366;

export const getDailySuggestions = (date = new Date()) => {
  const d = dayIndex(date);
  const n = SUGGESTIONS.length;
  return [SUGGESTIONS[d % n], SUGGESTIONS[(d + 5) % n], SUGGESTIONS[(d + 9) % n]];
};

export const greeting = (date = new Date()) => {
  const h = date.getHours();
  if (h < 6) return "Bonne nuit";
  if (h < 12) return "Bonjour";
  if (h < 18) return "Bon après-midi";
  return "Bonsoir";
};
